export default __webpack_public_path__ + "static/songbird-stroll-ring-eb709e73d66f761f8447b52cc401449b.png";